import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getMortarElectric } from '@/service/production/ProReportMortar';
export default function useMortarElectirc(params) {
  var mortarElectric = ref({
    totalSettleValue: 0,
    totalAveragePrice: 0,
    electric: 0,
    totalMoney: 0,
    tonEle: 0,
    totalSingular: 0
  });
  // 获取主机汇总数据
  var getMortarElectricAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMortarElectric(params.value);
          case 2:
            data = _context.sent;
            mortarElectric.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMortarElectricAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [mortarElectric, getMortarElectricAsync];
}